import { TradeMethodParsingsPage } from 'features/trade-methods';

export const TechOperatorTradeMethodParsingsPage = () => (
  <TradeMethodParsingsPage />
);
